import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { general_MailUnread_str, general_Phone_str, } from '@zenlayer/zen-design-icons';
import { SvgIcon, LaunchCode, Space, Typography, } from '@zenlayer/zen-design';
import t from '@zenlayer/zen-intl18';
import React from 'react';
import { useEffect } from 'react';
import useCountDown from 'react-countdown-hook';
import '@zenlayer/zen-design-icons/assets/general/Phone.svg';
import '@zenlayer/zen-design-icons/assets/general/MailUnread.svg';
import './index.less';
export var EMethods;
(function (EMethods) {
    EMethods["EMAIL"] = "EMAIL";
    EMethods["TOTP"] = "TOTP";
})(EMethods || (EMethods = {}));
const VerifyEmail = ({ methods, onMethodChange, email, onEditEmail, onResendCaptcha, onVerify, verifyLoading, }) => {
    const [timeLeft, { start }] = useCountDown(60 * 1000);
    useEffect(() => {
        start();
    }, []);
    return (_jsxs(Space, { direction: "vertical", size: "ll", block: true, className: "verify", children: [_jsxs(Space, { align: "center", children: [_jsx(SvgIcon, { svgStr: general_MailUnread_str, block: true, fontSize: 16 }), _jsx(Typography.Title, { size: "14-20", children: t('VdlAUATXJIt2') })] }), _jsxs(Space, { direction: "vertical", size: 0, children: [_jsxs("span", { children: [t('5G41puj3n5RM'), " ", _jsx("a", { href: `mailto:${email}`, children: email })] }), _jsx("span", { children: t('a-VaPnKElG99') })] }), _jsxs(Space, { direction: "vertical", size: 4, block: true, children: [_jsx("span", { className: 'description', children: t('4M9ARa_FmrDk') }), _jsx(LaunchCode, { type: "input", loading: verifyLoading, onOk: (value) => {
                            onVerify(EMethods.EMAIL, value);
                        } })] }), _jsxs("span", { className: 'description', children: [!!onResendCaptcha && (_jsxs(_Fragment, { children: [_jsx("span", { children: t('WW3a8SCsjByU') }), "\u00A0", _jsx("a", { className: timeLeft > 0 ? 'a_disabled' : undefined, onClick: () => {
                                    if (!(timeLeft > 0)) {
                                        start();
                                        onResendCaptcha();
                                    }
                                }, children: t('cHKOnAPBvYwM', [timeLeft > 0 ? ` (${timeLeft / 1000})` : '']) })] })), "\u00A0", !!onEditEmail && (_jsxs(_Fragment, { children: [_jsx("span", { children: t('WWE_EUhtgNPW') }), "\u00A0", _jsx("a", { className: verifyLoading ? 'a_disabled' : undefined, onClick: () => {
                                    !verifyLoading && onEditEmail();
                                }, children: t('J4mzLPNAQm3L') })] }))] }), methods?.includes(EMethods.TOTP) && !!onMethodChange && (_jsxs(Space, { className: 'description', size: 4, children: [_jsx("span", { children: t('Zfj2DqN11Yim') }), _jsx("a", { className: verifyLoading ? 'a_disabled' : undefined, onClick: () => {
                            !verifyLoading && onMethodChange(EMethods.TOTP);
                        }, children: t('CNzyxegpiBjw') })] }))] }));
};
const VerifyTOTP = ({ methods, onMethodChange, onVerify, verifyLoading }) => {
    return (_jsxs(Space, { direction: "vertical", size: "ll", block: true, children: [_jsxs(Space, { align: "center", children: [_jsx(SvgIcon, { svgStr: general_Phone_str, block: true, fontSize: 16 }), _jsx(Typography.Title, { size: "14-20", children: t('azEaBzC6OFVm') })] }), _jsxs(Typography.Text, { size: "16-20", strong: true, type: "senior", children: [_jsx("div", { children: t('JGPl6PlCYidJ') }), _jsx("div", { children: t('5Kv1vGtCUbVq') })] }), _jsxs(Space, { direction: "vertical", size: 4, block: true, children: [_jsx("span", { className: 'description', children: t('WvQ3eAXmURBj') }), _jsx(LaunchCode, { type: "input", loading: verifyLoading, onOk: (value) => {
                            onVerify(EMethods.TOTP, value);
                        } })] }), methods?.includes(EMethods.EMAIL) && !!onMethodChange && (_jsxs(Space, { className: 'description', children: [_jsx("span", { children: t('Zfj2DqN11Yim') }), _jsx("a", { className: verifyLoading ? 'a_disabled' : undefined, onClick: () => {
                            !verifyLoading && onMethodChange(EMethods.EMAIL);
                        }, children: t('kSeRGm4u7Qvy') })] }))] }));
};
export const Verify = (props) => {
    const { methods, onResendCaptcha } = props;
    const [method, setMethod] = React.useState();
    console.log(method, methods);
    useEffect(() => {
        if (methods.includes(EMethods.TOTP)) {
            setMethod(EMethods.TOTP);
        }
        else if (methods.includes(EMethods.EMAIL)) {
            setMethod(EMethods.EMAIL);
        }
        else {
            setMethod(undefined);
        }
    }, [methods]);
    if (method === EMethods.TOTP) {
        return (_jsx(VerifyTOTP, { ...props, onMethodChange: (method) => {
                if (method === EMethods.EMAIL) {
                    onResendCaptcha?.();
                }
                setMethod(method);
            } }));
    }
    else if (method === EMethods.EMAIL) {
        return _jsx(VerifyEmail, { ...props, onMethodChange: setMethod });
    }
    return null;
};
